import { Theme } from "@bluframe/blublocks"
import styled from "styled-components"

export const Wrapper = styled.div`
  align-items: center;
  background: ${({ theme }: { theme: Theme }) => theme.palette.text.contrast};
  display: grid;
  justify-items: center;
`

export const Logo = styled.img`
  width: 80px;
`
